import React from 'react';
import img1 from '../../assets/img/img1.jpg';

import './Presentation.css';

const Presentation = () => {
  return (
    <div className="presentation-container">
      <div className="image-section">
        <img src={img1} alt="Imagen 1" />
      </div>
      <div className="separator"></div>
      <div className="text-section">
        <h2>UNA VISTA DE QUIENES SOMOS</h2>
        <p>
          Nos especializamos en proporcionar a nuestros clientes servicios integrales de la más alta calidad, respaldados por un equipo de
          profesionales con amplia experiencia y conocimientos especializados
          en diversos sectores.
          Nuestra misión es brindar soluciones excepcionales en materia legal,
          comercial, cumplimiento tributario (tax compliance), y otros servicios
          orientados a satisfacer las necesidades particulares de nuestros
          clientes. Nos comprometemos a ofrecer un enfoque personalizado y
          estratégico, garantizando resultados óptimos que cumplan con los
          más altos estándares profesionales y éticos en cada uno de nuestros
          mercados.
        </p>
      </div>
    </div>
  );
};

export default Presentation;